import { api_json } from './api'

/**
 * Sessão do anunciante no lado do navegador (F6.2).
 *
 * **Não reusa `lib/auth.ts`.** Aquele módulo cacheia o usuário OPERADOR e é lido
 * por `has_acl`; misturar as duas identidades num cache só faria uma sessão de
 * rua aparecer onde o código pergunta "quem é o operador?".
 */

export type AdvertiserAccount = { email: string; email_verified: boolean }

let cache: AdvertiserAccount | null = null
let checado = false

export async function refresh_advertiser(force = false): Promise<AdvertiserAccount | null> {
  if (checado && !force) return cache
  try {
    const r = await api_json<{ account: AdvertiserAccount }>('/api/advertiser/me')
    cache = r.account
  } catch {
    // 401 é o caso normal de quem não entrou; qualquer outra falha também não
    // pode virar "está logado".
    cache = null
  }
  checado = true
  return cache
}

export function get_cached_advertiser(): AdvertiserAccount | null {
  return cache
}

export async function advertiser_is_logged_in(): Promise<boolean> {
  return Boolean(await refresh_advertiser())
}

export function clear_advertiser_cache(): void {
  cache = null
  checado = false
}
